(function () {
  if (window.__gaNecklaceSizeInteractionInstalled) return;
  window.__gaNecklaceSizeInteractionInstalled = true;

  var POSITIONS = {
    35: { top: 52.3, width: 43, height: 5.0 },
    40: { top: 55.8, width: 48, height: 5.0 },
    45: { top: 59.7, width: 52, height: 5.2 },
    50: { top: 63.3, width: 56, height: 5.2 },
    60: { top: 70.8, width: 60, height: 5.4 },
    70: { top: 78.3, width: 64, height: 5.4 },
    80: { top: 86.3, width: 66, height: 5.5 },
    90: { top: 94.2, width: 68, height: 5.5 }
  };

  var CHAIN_PATHS = {
    35: 'M37.2 47.8 C40.0 57.2 45.0 62.8 50 62.8 C55.0 62.8 60.0 57.2 62.8 47.8',
    40: 'M36.8 47.8 C39.8 60.2 44.8 67.0 50 67.0 C55.2 67.0 60.2 60.2 63.2 47.8',
    45: 'M36.2 47.5 C39.4 63.6 44.6 71.6 50 71.6 C55.4 71.6 60.6 63.6 63.8 47.5',
    50: 'M35.8 47.2 C39.2 66.6 44.2 76.0 50 76.0 C55.8 76.0 60.8 66.6 64.2 47.2',
    60: 'M35.2 46.8 C38.8 74.0 43.8 85.0 50 85.0 C56.2 85.0 61.2 74.0 64.8 46.8',
    70: 'M34.8 46.5 C38.5 81.5 43.4 94.0 50 94.0 C56.6 94.0 61.5 81.5 65.2 46.5',
    80: 'M34.4 46.2 C38.2 89.5 43.0 103.5 50 103.5 C57.0 103.5 61.8 89.5 65.6 46.2',
    90: 'M34.0 46.0 C37.8 96.5 42.7 113.0 50 113.0 C57.3 113.0 62.2 96.5 66.0 46.0'
  };

  function drawer() {
    return document.getElementById('gaNecklaceSizeDrawer');
  }

  function getCm(element) {
    if (!element) return null;
    var raw = element.getAttribute('data-ga-necklace-length') ||
      element.getAttribute('data-ga-necklace-hotspot') ||
      element.textContent || '';
    var match = String(raw).match(/(\d+(?:\.\d+)?)\s*cm/i);
    if (!match) match = String(raw).match(/^\s*(\d+(?:\.\d+)?)/);
    return match ? Number(match[1]) : null;
  }

  function textFor(cm) {
    if (cm <= 35) return 'Close choker — sits low and close around the neck.';
    if (cm <= 40) return 'Base-of-neck length — a little lower than a close choker.';
    if (cm <= 45) return 'Classic everyday length — lands around the collarbone.';
    if (cm <= 50) return 'Below-collarbone length — easy for pendants and layering.';
    if (cm <= 60) return 'Mid-chest length — a longer, relaxed drop.';
    if (cm <= 70) return 'Long length — typically sits just above the bust.';
    if (cm <= 80) return 'Statement length — typically around the bust line.';
    return 'Extra-long length — designed to fall below the bust line.';
  }


  function ensureOverlay(visual) {
    if (!visual || visual.querySelector('[data-ga-necklace-overlay]')) return;

    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'ga-necklace-drawer-overlay');
    svg.setAttribute('viewBox', '0 0 100 120');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('data-ga-necklace-overlay', '');

    svg.innerHTML =
      '<defs>' +
        '<linearGradient id="ga-drawer-necklace-gold-gradient" x1="34" y1="0" x2="66" y2="0" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0" stop-color="#b98731" stop-opacity="0"></stop>' +
          '<stop offset=".16" stop-color="#c9973d" stop-opacity=".60"></stop>' +
          '<stop offset=".30" stop-color="#e2bd68"></stop>' +
          '<stop offset=".5" stop-color="#d6aa4c"></stop>' +
          '<stop offset=".70" stop-color="#e2bd68"></stop>' +
          '<stop offset=".84" stop-color="#c9973d" stop-opacity=".60"></stop>' +
          '<stop offset="1" stop-color="#b98731" stop-opacity="0"></stop>' +
        '</linearGradient>' +
        '<linearGradient id="ga-drawer-necklace-highlight-gradient" x1="34" y1="0" x2="66" y2="0" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0" stop-color="#fff1b8" stop-opacity="0"></stop>' +
          '<stop offset=".18" stop-color="#fff0ad" stop-opacity=".42"></stop>' +
          '<stop offset=".5" stop-color="#fff3c4" stop-opacity=".88"></stop>' +
          '<stop offset=".82" stop-color="#fff0ad" stop-opacity=".42"></stop>' +
          '<stop offset="1" stop-color="#fff1b8" stop-opacity="0"></stop>' +
        '</linearGradient>' +
        '<linearGradient id="ga-drawer-necklace-shadow-gradient" x1="34" y1="0" x2="66" y2="0" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0" stop-color="#39250e" stop-opacity="0"></stop>' +
          '<stop offset=".18" stop-color="#39250e" stop-opacity=".18"></stop>' +
          '<stop offset=".5" stop-color="#39250e" stop-opacity=".32"></stop>' +
          '<stop offset=".82" stop-color="#39250e" stop-opacity=".18"></stop>' +
          '<stop offset="1" stop-color="#39250e" stop-opacity="0"></stop>' +
        '</linearGradient>' +
      '</defs>';

    Object.keys(CHAIN_PATHS).forEach(function (key) {
      var g = document.createElementNS(ns, 'g');
      g.setAttribute('class', 'ga-necklace-drawer-chain');
      g.setAttribute('data-ga-necklace-chain', key);

      ['ga-necklace-drawer-shadow', 'ga-necklace-drawer-base', 'ga-necklace-drawer-links'].forEach(function (className) {
        var path = document.createElementNS(ns, 'path');
        path.setAttribute('class', className);
        path.setAttribute('d', CHAIN_PATHS[key]);
        g.appendChild(path);
      });

      svg.appendChild(g);
    });

    visual.appendChild(svg);
  }

  function findLengthButton(root, cm) {
    if (!root) return null;
    var buttons = root.querySelectorAll('[data-ga-necklace-length]');
    for (var i = 0; i < buttons.length; i += 1) {
      if (getCm(buttons[i]) === cm) return buttons[i];
    }
    return null;
  }

  function activate(cm, sourceButton) {
    var root = drawer();
    if (!root || !POSITIONS[cm]) return;

    root.querySelectorAll('[data-ga-necklace-length]').forEach(function (button) {
      var active = button === sourceButton || (!sourceButton && getCm(button) === cm);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-ga-necklace-hotspot]').forEach(function (spot) {
      var active = getCm(spot) === cm;
      spot.classList.toggle('is-active', active);
      spot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-ga-necklace-chain]').forEach(function (chain) {
      chain.classList.toggle('is-active', Number(chain.getAttribute('data-ga-necklace-chain')) === cm);
    });

    var guidance = root.querySelector('[data-ga-necklace-guidance]');
    if (guidance) guidance.textContent = textFor(cm);
  }

  function build() {
    var root = drawer();
    if (!root) return false;
    var visual = root.querySelector('.ga-necklace-size-drawer__visual');
    if (!visual) return false;

    ensureOverlay(visual);

    if (visual.getAttribute('data-ga-necklace-visual-ready') !== 'true') {
      visual.setAttribute('data-ga-necklace-visual-ready', 'true');
      visual.setAttribute('aria-label', 'Choose a necklace length on the model');

      root.querySelectorAll('[data-ga-necklace-length]').forEach(function (lengthButton) {
        var cm = getCm(lengthButton);
        var position = POSITIONS[cm];
        if (!position) return;

        var hotspot = document.createElement('button');
        hotspot.type = 'button';
        hotspot.className = 'ga-necklace-size-hotspot';
        hotspot.setAttribute('data-ga-necklace-hotspot', String(cm));
        hotspot.setAttribute('aria-pressed', 'false');
        hotspot.setAttribute('aria-label', 'Show ' + lengthButton.textContent.trim() + ' on the model');
        hotspot.style.setProperty('--ga-necklace-hotspot-top', position.top + '%');
        hotspot.style.setProperty('--ga-necklace-hotspot-width', position.width + '%');
        hotspot.style.setProperty('--ga-necklace-hotspot-height', position.height + '%');

        var label = document.createElement('span');
        label.className = 'ga-necklace-size-hotspot__label';
        label.textContent = lengthButton.textContent.trim();
        hotspot.appendChild(label);
        visual.appendChild(hotspot);
      });
    }

    var selected = root.querySelector('[data-ga-necklace-length][aria-pressed="true"]') || root.querySelector('[data-ga-necklace-length]');
    if (selected) activate(getCm(selected), selected);
    return true;
  }

  document.addEventListener('click', function (event) {
    var hotspot = event.target.closest && event.target.closest('[data-ga-necklace-hotspot]');
    if (hotspot) {
      var root = drawer();
      if (!root || !root.contains(hotspot)) return;
      event.preventDefault();
      event.stopPropagation();
      var cm = getCm(hotspot);
      var matchingButton = findLengthButton(root, cm);
      if (matchingButton) {
        matchingButton.click();
        activate(cm, matchingButton);
      } else {
        activate(cm, null);
      }
      return;
    }

    var lengthButton = event.target.closest && event.target.closest('#gaNecklaceSizeDrawer [data-ga-necklace-length]');
    if (lengthButton) {
      var cm = getCm(lengthButton);
      if (cm) window.setTimeout(function () { activate(cm, lengthButton); }, 0);
    }
  });

  function mountSoon() { window.setTimeout(build, 0); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountSoon, { once: true });
  } else {
    mountSoon();
  }

  window.addEventListener('pageshow', mountSoon, { passive: true });
  document.addEventListener('shopify:section:load', mountSoon);
})();
